import type { LabelState } from "@repo/types"
import { create } from "zustand"

export const useLabel = create<LabelState>((set) => ({
  set: (label) => set(() => ({ label })),
  clear: () => set({ label: undefined }),
  label: undefined
}))
